// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"4b135d93","496":"8d8889c6","647":"45981844"}[chunkId] + ".chunk.js";
};